import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";
import {selectIdUser, selectUserIdClientAccount} from "./userSlice";
import limApi from "../../apis/limApi";

export const getUIConfigs = createAsyncThunk(
    "uiConfig/fetchAll",
    async (_, {getState, rejectWithValue}) => {
        try {
            const idClientAccount = selectUserIdClientAccount(getState());

            const response = await limApi.get(`/userinfo/ui-configs${idClientAccount ? '?idClientAccount=' + idClientAccount : ''}`);
            return response.data;
        } catch (e) {
            return rejectWithValue(e);
        }
    }
);

export const putUIConfig = createAsyncThunk(
    "uiConfig/upsert",
    async ({key, value}, {rejectWithValue, getState}) => {
        try {
            const state = getState();
            
            const idClientAccount = selectUserIdClientAccount(state);
            const idUser = selectIdUser(state);

            const data = {
                idUser: idUser ?? null,
                idClientAccount: idClientAccount ?? null,
                idApplication: process.env.REACT_APP_IGL_API_ID_APPLICATION,
                key,
                value
            }

            const response = await limApi.put(`/userinfo/ui-configs${idClientAccount ? '?idClientAccount=' + idClientAccount : ''}`, data);
            return response.data;
        } catch (e) {
            return rejectWithValue(e);
        }
    }
);

export const deleteUIConfig = createAsyncThunk(
    "uiConfig/delete",
    async (key, {rejectWithValue, getState}) => {
        try {
            const idClientAccount = selectUserIdClientAccount(getState());

            await limApi.delete(`/userinfo/ui-configs/${key}${idClientAccount ? '?idClientAccount=' + idClientAccount : ''}`);

            return {
                key,
                idClientAccount: idClientAccount ?? null
            };
        } catch (e) {
            return rejectWithValue(e);
        }
    }
);

const uiConfigSlice = createSlice({
    name: 'uiConfig',
    initialState: {
        loading: undefined,
        settings: undefined
    },
    extraReducers: builder => {
        builder
            .addCase(getUIConfigs.pending, state => {
                state.loading = true;
            })
            .addCase(getUIConfigs.fulfilled, (state, action) => {
                state.loading = undefined;
                state.settings = action.payload;
            })
            .addCase(getUIConfigs.rejected, state => {
                state.loading = undefined;
            })
            .addCase(putUIConfig.fulfilled, (state, action) => {
                const configIndex = state.settings.findIndex(c =>
                    c.idConfiguration === action.payload.idConfiguration
                );

                if (configIndex >= 0) {
                    state.settings[configIndex] = action.payload;
                } else {
                    state.settings.push(action.payload);
                }
            })
            .addCase(deleteUIConfig.fulfilled, (state, action) => {
                state.settings = state.settings.filter(c => c.key !== action.payload.key && c.idClientAccount !== action.payload.idClientAccount);
            })
    }
});

export const selectUIConfigByKey = key => state => {
    const idClientAccount = selectUserIdClientAccount(state) ?? null;

    return state.uiConfig?.settings.find(c => c.idClientAccount === idClientAccount && c.key === key);
}

export default uiConfigSlice.reducer;